import StarterKit from '@tiptap/starter-kit';

import { COMMUNITY_NODE_CLASS_NAMES } from '../utils/communityContent/communityNodeStyle';

export const createCommunityStarterKit = () =>
  StarterKit.configure({
    codeBlock: false,
    horizontalRule: false,
    heading: { HTMLAttributes: { class: COMMUNITY_NODE_CLASS_NAMES.heading } },
    bulletList: { HTMLAttributes: { class: COMMUNITY_NODE_CLASS_NAMES.bulletList } },
    orderedList: { HTMLAttributes: { class: COMMUNITY_NODE_CLASS_NAMES.orderedList } },
    listItem: { HTMLAttributes: { class: COMMUNITY_NODE_CLASS_NAMES.listItem } },
    blockquote: { HTMLAttributes: { class: COMMUNITY_NODE_CLASS_NAMES.blockquote } },
  });
